<template>

	<b-row>
		<b-col class="mt-2 mb-5">
			<agile class="thumbnails" ref="main" :options="options" :nav-bittons="true">
				<div class="slide" v-for="(slide, index) in images" :key="index" :class="`slide--${index}`"><img :src="slide.url"/></div>
			</agile>
		</b-col>
	</b-row>

</template>  
<script>
import { VueAgile } from 'vue-agile';
	export default {
		name: 'v-carousel',
		components: {
		agile: VueAgile
	},
		data() {
			return {
				images: [],
				options: {
					autoplay: true,
					centerMode: true,
					dots: false,
					navButtons: false,
					slidesToShow: 3,	
				},
			}
    },
    mounted(){
      this.set_images()
    },
    methods:{
      set_images(){
        let self = this;
        this.axios.get("sale_opportunitie_images").then(result => {
          if(typeof result.data.length != undefined){
            let data = []
            result.data.map(function(value) {
              data.push({url: value.url_image, link: value.url_link})
            });
            self.images = data;
          }
        }).catch(() => {
        })
      }
    }
	} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px);
}

.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
}
.thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}
.thumbnails .agile__nav-button--prev {
  left: -45px;
}
.thumbnails .agile__nav-button--next {
  right: -45px;
}
.agile__nav-button:hover {
  color: #888;
}
.agile__dot {
  margin: 0 10px;
}
.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
  width: 10px;
}
.agile__dot--current button, .agile__dot:hover button {
  background-color: #888;
}

.slide {
  -webkit-box-align: center;
          align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: -webkit-box;
  display: flex;
  height: 450px;
  -webkit-box-pack: center;
          justify-content: center;
}
.slide--thumbniail {
  cursor: pointer;
  height: 100px;
  padding: 0 5px;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.slide--thumbniail:hover {
  opacity: 0.75;
}
.slide img {
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  -o-object-position: center;
     object-position: center;
  width: 100%;
}
</style>
